var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.prefixCls},[_c('div',{class:(_vm.prefixCls + "-nav")},[_vm._l((_vm.navList),function(item,index){return _c('div',{key:index,class:_vm.classes(item),on:{"click":function($event){_vm.handleChange(index)}}},[_vm._v("\n            "+_vm._s(item.label)+"\n        ")])}),_vm._v(" "),(_vm.showSlot)?_c('div',{class:(_vm.prefixCls + "-extra")},[_vm._t("extra")],2):_vm._e()],2),_vm._v(" "),_c('div',{ref:"panes",class:(_vm.prefixCls + "-content")},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/base/tabs/tabs.vue?vue&type=template&id=8222e78e&
// module id = 157
// module chunks = 0